<template>
  <div class="sidebarResults" v-show="show">
    <transition name="fade" mode="out-in">
      <ul class="side-menu" v-if="show">
        <li @click="$router.push('/multiomics')">首页</li>
        <li @click="$router.push('/conclusion')">查看综合结论</li>
        <li @click="$router.push('/ceramide')">我的代谢物CER</li>
        <li @click="$router.push('/coming')">我的遗传携带</li>
        <li @click="$router.push('/assessment')">我的传统风险</li>
      </ul>
    </transition>
    <div class="shadow"></div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  data () {
    return {
      gdb3: false,
      gdb2: false,
      sample_type: this.util.getLS(this.api.sample_type)
    }
  },
  props: ['show'],
  components: {
    Dialog
  },
  methods: {
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
    } else {
      this.gdb2 = true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/functions";
  .sidebarResults, .sidebarResults .shadow {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .sidebarResults {
    position: fixed;
    z-index: 999;
  }
  .sidebarResults .shadow,
  .sidebarResults .side-menu {
    position: absolute;
  }
  .sidebarResults .side-menu {
    top: pxToRem(70px);
    right: 0;
    background-color: #2A6BAE;
    text-align: center;
    z-index: 1000;
    // transition: all .5s;
  }
  .sidebarResults .shadow {
    top: pxToRem(70px);
    background-color: rgba(0, 0, 0, .5);
  }
  .sidebarResults .side-menu li {
    width: pxToRem(250px);
    height: pxToRem(70px);
    line-height: pxToRem(70px);
    color: #fff;
    border-bottom: 1px solid #C4E3FE;
    font-size: pxToRem(20px);
    letter-spacing: 1px;
  }
  .sidebarResults .side-menu li:last-of-type {
    border: none;
    border: 0;
  }

    .fade-enter-active {
    transition: all .3s ease;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/SideBarResults.vue